export const THEME = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export const DEFAULT_THEME = THEME.LIGHT;

/** 테마 쿠키 유효 기간 (초). 1년 */
export const THEME_COOKIE_MAX_AGE = 31536000;
